

export const EditSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ["button_link", "button_text"],
    },
  ],

  properties: {
    button_link: {
      title: 'Button Link',
      type: 'string',
    },
    button_text : {
      title: 'Button Text',
      type: 'string',
    },
    
  },
  required: [],
});
